export default __webpack_public_path__ + "static/media/tabla.6be38000.png";